//FlexiItemContent: To be used by standardized controllers. Controllers hold configuration.contentelements which this controller digests and renders.
//With rendering and a full configuration system, we may as well roll out a new onChange handler, maybe just break that out into a separate functional controller. 
//REMEMBER THESE CONCEPTS:
//     localstate.itemdata is the WHAT
//     configuration.contentelements....(where element.type===someinputtype) will need validation rules (element.validationrules) per input
//


import FlexiItemSection from './FlexiItemSection';
import FlexiItemChangeHandler from './FlexiItemChangeHandler';

import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl'; 
import Select from '@mui/material/Select';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import TextareaAutosize from '@mui/material/TextareaAutosize'; 
import Checkbox from '@mui/material/Checkbox';

//DateTime
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; //Possibly our new adapter for mui x 7 datetime
import dayjs from 'dayjs'; //Used with new datetimepickers
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import ViewListIcon from '@mui/icons-material/ViewList';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Link } from 'react-router-dom'; 

//DBAutoComplete
import DBAutoComplete from '../../common/DBAutoComplete';


var hostbase = process.env.REACT_APP_BASE;

//I wanted to make sure the delete functionality stayed universal, away from the parent controller.

//Allow recursive creation of elements. Woah!
const RenderElement = ({ element, localstate, UpdateState, classes, perms }) => {
	switch (element.rendertype) {
		case "section":
			return <RenderSection element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;
		case "gridcontainer":
			return <RenderGridContainer element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;
		case "kvstaticinputtext":
			return <KVRenderStaticInputText element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} />;
		case "kvinputtext":
			return <KVRenderInputText element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;
		case "kvinputnumber":
			return <KVRenderInputNumber element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;
		case "kvstaticselect":
			return <KVRenderStaticSelect element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;

		//Datetimes
		case "kvstaticdatetime":
			return <KVRenderStaticDateTime element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;
		case "kvinputdatetime":
			return <KVRenderInputDateTime element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;

		//Date
		case "kvstaticdate":
			return <KVRenderStaticDate element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;
		case "kvinputdate":
			return <KVRenderInputDate element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;

		//Creation User
		case "kvcreationuser":
			return <KVRenderCreationUser element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;
		//Update User
		case "kvupdateuser":
			return <KVRenderUpdateUser element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;

		case "kvproductbyid":
			return <KVRenderProductSelection element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;
		case "kvpartbyid":
			return <KVRenderPartSelection element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;
		case "kvinputtextarea":
			return <KVRenderInputTextArea element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;
		case "kvinputcheckbox":
			return <KVRenderInputCheckbox element={element} localstate={localstate} UpdateState={UpdateState} classes={classes} perms={perms} />;
		default:
			return null;
	}
};

const RenderSection = ({ element, localstate, UpdateState, classes, perms }) => {
	return (
		<div style={{ borderRadius: "4px", border: "1px solid #BBB", margin:"0px 10px" }}>
			<div style={{ height: "30px", borderBottom: "2px solid #AAA", backgroundColor: "#DDD", textAlign: "left", padding: "5px 0px 1px 8px" }}>
				<span style={{ fontSize: "1.1em", fontWeight: "400" }}>
					{element.title}
				</span>
				{element.description ?
					<span style={{ fontSize: "0.8em" }}> - {element.description}</span> : ""
				}
			</div>
			<div style={{ backgroundColor: "#FFF", padding:"10px"}}>
				{element.children.map((childelement, childelementindex) => {
					return <RenderElement element={childelement} localstate={localstate} UpdateState={UpdateState} perms={perms} classes={classes} />
				})}
			</div>
		</div>
	)
}

const RenderGridContainer = ({ element, localstate, UpdateState, classes, perms }) => {
	return (
		<Grid container>
			{element.children.map((childelement, childelementindex) => {
				return <RenderGridItem element={childelement} localstate={localstate} UpdateState={UpdateState} perms={perms} classes={classes} />
			})}
		</Grid>
	)
}

const RenderGridItem = ({ element, localstate, UpdateState, classes, perms }) => {
	//Doublecheck that this is a grid item.
	if (element.rendertype === "griditem") {
		return (
			<Grid size={{
				xs:element.size.xs,
				sm:element.size.sm,
				md:element.size.md,
				lg:element.size.lg

			}}>
				{element.children.map((childelement, childelementindex) => {
					return <RenderElement element={childelement} localstate={localstate} UpdateState={UpdateState} perms={perms} classes={classes} />
				})}
			</Grid>
		)
	}
}

const KVRenderStaticInputText = ({ element, localstate, classes, UpdateState }) => {
	return (
		<Grid container wrap="nowrap">
			<Grid sx={{ width: element.labelwidth, flexShrink: 0, textAlign:"right" }}>
				{/* Label */}
				<div className={classes.kvlabel} style={{textAlign:element.labeltextAlign}}>
					{element.label}
				</div>
			</Grid>
			<Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150 }}>
				{/* Value */}
				<div className={classes.kvstaticinput} style={{textAlign:element.valuetextAlign}}>
					{localstate.itemdata[element.dbfield]}
				</div>
			</Grid>

		</Grid>
	)
}

const KVRenderInputText = ({ element, localstate, classes, UpdateState, perms }) => {
	return (
		<Grid container wrap="nowrap">
			<Grid sx={{ width: element.labelwidth, flexShrink: 0, textAlign:"right" }}>
				{/* Label */}
				<div className={classes.kvlabel} style={{textAlign:element.labeltextAlign}}>
					{element.label}
				</div>
			</Grid>
			<Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150 }}>
				{/* Value */}
				{(perms.updatePerm) &&
					<input className={classes.kvtextinput} style={{textAlign:element.valuetextAlign}}
						maxLength="100" //Needs max length
						type="text"
						value={localstate.itemdata[element.dbfield]}
						onChange={(event) => FlexiItemChangeHandler({ localstate, UpdateState, element, event })}
					/>
				}
				{(!perms.updatePerm) &&
					<div className={classes.kvstaticinput} style={{ textAlign: element.valuetextAlign }}>
						{localstate.itemdata[element.dbfield]}
					</div>
				}
			</Grid>

		</Grid>
	)
}

const KVRenderInputNumber = ({ element, localstate, classes, UpdateState, perms }) => {
	return (
		<Grid container wrap="nowrap">
			<Grid sx={{ width: element.labelwidth, flexShrink: 0, textAlign:"right" }}>
				{/* Label */}
				<div className={classes.kvlabel} style={{textAlign:element.labeltextAlign}}>
					{element.label}
				</div>
			</Grid>
			<Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150 }}>
				{/* Value */}
				{(perms.updatePerm) &&
					<input className={classes.kvtextinput} style={{textAlign:element.valuetextAlign}}
						type="number"
						min={element.validation.min}
						max={element.validation.max}
						step={element.step}
						value={localstate.itemdata[element.dbfield] ? localstate.itemdata[element.dbfield] : 0}
						onChange={(event) => FlexiItemChangeHandler({ localstate, UpdateState, element, event })}
					/>
				}
				{(!perms.updatePerm) &&
					<div className={classes.kvstaticinput} style={{ textAlign: element.valuetextAlign }}>
						{localstate.itemdata[element.dbfield]}
					</div>
				}
			</Grid>

		</Grid>
	)
}

const KVRenderStaticSelect = ({ element, localstate, classes, UpdateState, perms }) => {
	return (
		<Grid container wrap="nowrap">
			<Grid sx={{ width: element.labelwidth, flexShrink: 0, textAlign:"right" }}>
				{/* Label */}
				<div className={classes.kvlabel} style={{textAlign:element.labeltextAlign}}>
					{element.label}
				</div>
			</Grid>
			<Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150 }}>
				{/* Value */}
				{(perms.updatePerm) &&
					<FormControl variant="standard" className={classes.kvstaticselect} sx={{ m: 0, width: "100%", border: "0px", textAlign:element.valuetextAlign }}>
					<Select
						variant="standard"
						value={localstate.itemdata[element.dbfield]}
						displayEmpty
						onChange={(event) => FlexiItemChangeHandler({ localstate, UpdateState, element, event })}
						//Setting value means React will try to consider this a controlled component.
						//If you don't set a default value in state (before DB load), it will try to evaluate an undefined value and switch back to uncontrolled.
						//This will present an error when the component tries to go back to controlled.
						renderValue={
							(selected) => {
								return <Typography variant="h6">{localstate.itemdata.Name}</Typography>;
							}
						}
					>
						<MenuItem value={"James"}>James</MenuItem>
						<MenuItem value={"Martin"}>Martin</MenuItem>
						<MenuItem value={"Adam"}>Adam</MenuItem>
					</Select>
				</FormControl>
				}
				{(!perms.updatePerm) &&
					<div className={classes.kvstaticinput} style={{ textAlign: element.valuetextAlign }}>
						{localstate.itemdata[element.dbfield]}
					</div>
				}
			</Grid>

		</Grid>
	)
}

const KVRenderStaticDateTime = ({ element, localstate, classes, UpdateState, perms }) => {
	return (
		<Grid container wrap="nowrap">
			<Grid sx={{ width: element.labelwidth, flexShrink: 0, textAlign:"right" }}>
				{/* Label */}
				<div className={classes.kvlabel} style={{textAlign:element.labeltextAlign}}>
					{element.label}
				</div>
			</Grid>
			<Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150 }}>
				{/* Value */}
				<div className={classes.kvstaticinput} style={{ textAlign: element.valuetextAlign }}>
					{dayjs(localstate.itemdata[element.dbfield]).format("MMMM D, YYYY [at] h:mma")}
				</div>
			</Grid>

		</Grid>
	)
}

const KVRenderInputDateTime = ({ element, localstate, classes, UpdateState, perms }) => {
	return (
		<Grid container wrap="nowrap">
			<Grid sx={{ width: element.labelwidth, flexShrink: 0, textAlign:"right" }}>
				{/* Label */}
				<div className={classes.kvlabel} style={{textAlign:element.labeltextAlign}}>
					{element.label}
				</div>
			</Grid>
			<Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150 }}>
				{/* Value */}
				{(perms.updatePerm) &&
					<div className={classes.flexitemdateinputcontainer} style={{textAlign:element.valuetextAlign}}>
						<DateTimePicker
							value={localstate.itemdata[element.dbfield]}
							onChange={(event) => FlexiItemChangeHandler({ localstate, UpdateState, element, event })}
							className={classes.flexitemdateinput}
						/>
					</div>
				}
				{(!perms.updatePerm) &&
					<div className={classes.kvstaticinput} style={{textAlign:element.valuetextAlign}}> 
						{dayjs(localstate.itemdata[element.dbfield]).format("MMMM D, YYYY [at] h:mma")}
					</div>
				}
			</Grid>

		</Grid>
	)
}


const KVRenderStaticDate = ({ element, localstate, classes, UpdateState, perms }) => { 
	return (
		<Grid container wrap="nowrap">
			<Grid sx={{ width: element.labelwidth, flexShrink: 0, textAlign:"right" }}>
				{/* Label */}
				<div className={classes.kvlabel} style={{textAlign:element.labeltextAlign}}>
					{element.label}
				</div>
			</Grid>
			<Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150 }}>
				{/* Value */}
				<div className={classes.kvstaticinput} style={{ textAlign: element.valuetextAlign }}>
					{dayjs(localstate.itemdata[element.dbfield]).format("MMMM D, YYYY")}
				</div>
			</Grid>

		</Grid>
	)
}

const KVRenderInputDate = ({ element, localstate, classes, UpdateState, perms }) => {
	return (
		<Grid container wrap="nowrap">
			<Grid sx={{ width: element.labelwidth, flexShrink: 0, textAlign:"right" }}>
				{/* Label */}
				<div className={classes.kvlabel} style={{textAlign:element.labeltextAlign}}>
					{element.label}
				</div>
			</Grid>
			<Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150 }}>
				{/* Value */}
				{(perms.updatePerm) &&
					<div className={classes.flexitemdateinputcontainer} style={{textAlign:element.valuetextAlign}}>
						<DatePicker
							value={dayjs(localstate.itemdata[element.dbfield])}
							onChange={(event) => FlexiItemChangeHandler({ localstate, UpdateState, element, event })}
							className={classes.flexitemdateinput}
						/>
					</div>
				}
				{(!perms.updatePerm) &&
					<div className={classes.kvstaticinput} style={{textAlign:element.valuetextAlign}}> 
						{dayjs(localstate.itemdata[element.dbfield]).format("MMMM D, YYYY")}
					</div>
				}
			</Grid>

		</Grid>
	)
}

const KVRenderCreationUser = ({ element, localstate, classes, UpdateState, perms }) => {
	//Check that creation user even exists before render
	if (localstate.itemdata.creationuser){
		return (
			<Grid container wrap="nowrap">
				<Grid sx={{ width: element.labelwidth, flexShrink: 0, textAlign:"right" }}>
					{/* Label */}
					<div className={classes.kvlabel} style={{textAlign:element.labeltextAlign}}>
						{element.label}
					</div>
				</Grid>
				<Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150 }}>
					{/* Value */}
					<div className={classes.kvstaticinput} style={{textAlign:element.valuetextAlign}}> 
						{localstate.itemdata.creationuser.firstname} {localstate.itemdata.creationuser.lastname}
					</div>
				</Grid>

			</Grid>
		)
	}
}

const KVRenderUpdateUser = ({ element, localstate, classes, UpdateState, perms }) => {
	if (localstate.itemdata.updateuser) {
		return (
			<Grid container wrap="nowrap">
				<Grid sx={{ width: element.labelwidth, flexShrink: 0, textAlign: "right" }}>
					{/* Label */}
					<div className={classes.kvlabel} style={{ textAlign: element.labeltextAlign }}>
						{element.label}
					</div>
				</Grid>
				<Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150 }}>
					{/* Value */}
					<div className={classes.kvstaticinput} style={{ textAlign: element.valuetextAlign }}>
						{localstate.itemdata.updateuser.firstname} {localstate.itemdata.updateuser.lastname}
					</div>
				</Grid>

			</Grid>
		)
	}
}

const KVRenderProductSelection = ({ element, localstate, classes, UpdateState, perms }) => {


	const onDBAutoCompleteChange = (newvalue, searchkey, itemindex) => {
		console.log(newvalue);
		//We can parse results by using keys - this makes the function reusable so we can insert many DBAutoComplete Components
		if (searchkey === "products") {
			//console.log("Set new value: "+newvalue.Vendor);
			//setDBAC(newvalue.Vendor);


			localstate.itemdata.ProductID = newvalue.ProductID;
			//ToggleSaveBtnStatus(true);
			UpdateState(localstate);

		}
	}

	return (
		<Grid container wrap="nowrap">
			<Grid sx={{ width: element.labelwidth, flexShrink: 0, textAlign:"right" }}>
				{/* Label */}
				<div className={classes.kvlabel} style={{textAlign:element.labeltextAlign}}>
					{element.label}
				</div>
			</Grid>
			<Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150 }}>
				{/* Value */}
					<DBAutoComplete
					keyedby="ID"
					searchtype="products"
					searchkey="Name"
					//itemindex={index}
					defaultsearchterm={(localstate.itemdata.product ? localstate.itemdata.product.Name : "")}
					limit="100"
					disabled={(perms.updatePerm ? false : true)}
					//errors={errors}
					allowadd={false}
					freeSolo={false}
					grayplaceholder="Add Product" 
					onDBAutoCompleteChange={onDBAutoCompleteChange}
					endadornment={(localstate.itemdata.product ?
						<div style={{ textAlign: "right", display: "inline-block" }}>
							<Link
								to={{
									pathname: "/product/" + localstate.itemdata.product.ProductID,
								}}
							>
								<OpenInNewIcon className={classes.transparenticon} color="primary" fontSize="medium">
								</OpenInNewIcon>
							</Link>

							<a href={hostbase + "/inventorymanager?ProductID=" + encodeURIComponent(localstate.itemdata.product.ProductID) + "&ProductName=" + encodeURIComponent(localstate.itemdata.product.Name)} target="_blank">
								<ViewListIcon className={classes.transparenticon} color="primary" fontSize="medium">
								</ViewListIcon>
							</a>
						</div> : false)
					}
					endadornmentsize={"45px"}
				/>
			</Grid>

		</Grid>
	)
}


const KVRenderPartSelection = ({ element, localstate, classes, UpdateState, perms }) => {


	const onDBAutoCompleteChange = (newvalue, searchkey, itemindex) => {
		console.log(newvalue);
		//We can parse results by using keys - this makes the function reusable so we can insert many DBAutoComplete Components
		if (searchkey === "parts") {
			//console.log("Set new value: "+newvalue.Vendor);
			//setDBAC(newvalue.Vendor);

			localstate.pendingupdate = true;
			localstate.itemdata.PartID = newvalue.ID;
			//ToggleSaveBtnStatus(true);
			UpdateState(localstate);

		}
	}

	return (
		<Grid container wrap="nowrap">
			<Grid sx={{ width: element.labelwidth, flexShrink: 0, textAlign:"right" }}>
				{/* Label */}
				<div className={classes.kvlabel} style={{textAlign:element.labeltextAlign}}>
					{element.label}
				</div>
			</Grid>
			<Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150 }}>
				{/* Value */}
					<DBAutoComplete
					keyedby="ID"
					searchtype="parts"
					searchkey="Name"
					//itemindex={index}
					defaultsearchterm={(localstate.itemdata.part ? localstate.itemdata.part.Name : "")}
					limit="100"
					disabled={(perms.updatePerm ? false : true)}
					//errors={errors}
					allowadd={false}
					freeSolo={false}
					//grayplaceholder="Add Product" 
					onDBAutoCompleteChange={onDBAutoCompleteChange}
					endadornment={(localstate.itemdata.part ?
						<div style={{ textAlign: "right", display: "inline-block" }}>
							<Link
								to={{
									pathname: "/part/" + localstate.itemdata.part.ID,
								}}
							>
								<OpenInNewIcon className={classes.transparenticon} color="primary" fontSize="medium">
								</OpenInNewIcon>
							</Link>							
						</div> : false)
					}
					endadornmentsize={"45px"}
				/>
			</Grid>

		</Grid>
	)
}





const KVRenderInputTextArea = ({ element, localstate, classes, UpdateState, perms }) => {
	return (
		<Grid container wrap="nowrap">
			<Grid sx={{ width: element.labelwidth, flexShrink: 0, textAlign:"right" }}>
				{/* Label */}
				<div className={classes.kvlabel} style={{textAlign:element.labeltextAlign}}>
					{element.label}
				</div>
			</Grid>
			<Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150 }}>
				{/* Value */}
						<TextareaAutosize
							disabled={perms.updatePerm ? false : true}
							style={{ minHeight: "50px", backgroundColor: element.backgroundColor }}
							className={classes.kvtextinput}
							value={localstate.itemdata[element.dbfield]}
							onChange={(event) => FlexiItemChangeHandler({ localstate, UpdateState, element, event })}
						/>
			</Grid>

		</Grid>
	)
}

const KVRenderInputCheckbox = ({ element, localstate, classes, UpdateState, perms }) => { 
	return (
		<Grid container wrap="nowrap">
			<Grid sx={{ width: element.labelwidth, flexShrink: 0, textAlign:"right" }}>
				{/* Label */}
				<div className={classes.kvlabel} style={{textAlign:element.labeltextAlign}}>
					{element.label}
				</div>
			</Grid>
			<Grid sx={{ flexGrow: 1, flexShrink: 1, minWidth: 150, textAlign:element.valuetextAlign}}>
				{/* Value */}
				<Checkbox
				sx={{padding:"0px"}}
				checked={(localstate.itemdata[element.dbfield] === 1 ? true : false)}
				onChange={(event) => FlexiItemChangeHandler({ localstate, UpdateState, element, event })} />	
			</Grid>

		</Grid>
	)
}

function FlexiItemContent({ configuration, localstate, UpdateState, classes, perms, dispatch }) {
	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			{configuration.contentelements.map((element, elementindex) => {
				return (
					<RenderElement element={element} localstate={localstate} UpdateState={UpdateState} perms={perms} classes={classes} />
				)
			})}
		</LocalizationProvider>
	)
}

export default FlexiItemContent;